import { render, staticRenderFns } from "./UserVerifyModal.vue?vue&type=template&id=a668b074&scoped=true&"
import script from "./UserVerifyModal.vue?vue&type=script&lang=js&"
export * from "./UserVerifyModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a668b074",
  null
  
)

export default component.exports